import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class AsWkt extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.aswkt',
        group: 'Parsers',
        title: 'ST as Text',
        description: `
      This component generates a new column with the WKT representation of geographies in another column.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Column with geographies definition',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */
                *, ST_ASTEXT(${connection.processInputGeogColumn(params.geo as string)}) AS ${params.geo}_wkt
              FROM ${connection.quoteName(params.source as string)}`
    } else if (connection.type === Provider.Oracle) {
      const geoColumn = params.geo as string
      const wktColumn = `${params.geo}_wkt`
      return dedent`SELECT SDO_UTIL.TO_WKTGEOMETRY(${geoColumn}) AS ${wktColumn}, t.*
              FROM ${connection.quoteName(params.source as string)} t`
    } else {
      return dedent`SELECT *, ST_ASTEXT(${connection.processInputGeogColumn(params.geo as string)}) AS ${params.geo}_wkt
              FROM ${connection.quoteName(params.source as string)}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_wkt`,
      type: ColumnDataType.String
    })
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { AsWkt }
